/**
 * 메뉴에서 숨긴 화면 — **권한이 아니라 "지금은 안 쓴다" 는 표시다.**
 *
 * ── 왜 별도 파일인가 ───────────────────────────────────────────────────────
 * 이 판정을 역할 목록(`allowedRoles`)으로 표현하면 **틀린 뜻이 된다.** 두 가지
 * 이유로 그렇다:
 *   ① `roleCanAccessRoute` 는 빈 역할 목록을 **전원 허용**으로 읽는다.
 *      숨기려고 목록을 비우면 정확히 반대가 된다.
 *   ② ADMIN 은 super-role 로 **항상 통과**한다. 그래서 어떤 역할 목록으로도
 *      관리자에게서 숨길 수 없다.
 * 즉 오너가 말한 "모두에게 숨겨주세요" 는 권한 축으로는 표현 자체가 불가능하다.
 *
 * 더 근본적으로, 이것은 권한 경계가 아니다. 없는 경계를 코드가 주장하게 두면
 * 나중에 "이 탭은 누구 권한이었지?" 를 되짚는 사람이 잘못된 답을 얻는다.
 * 그래서 판정을 `permissions.ts` 에 넣지 않고 이 파일에 따로 둔다 —
 * 한 객체에 두 뜻을 담지 않는다.
 *
 * ── 되살리는 방법 ─────────────────────────────────────────────────────────
 * 아래 목록에서 해당 경로만 지우면 끝이다. 사이드바 항목 정의와 라우트는
 * `Sidebar.tsx` · `router.tsx` 에 **그대로 살아 있다** — 오너가 "당장은"
 * 이라고 했으므로 지우지 않았다.
 */

/**
 * 오너 결정 2026-08-28 — "부품 카탈로그, 부품 입고, 공급사 탭은 모두에게
 * 숨겨주세요. 당장은 사용하지 않는 탭입니다."
 *
 * ⚠ 이 결정은 **2026-08-20 결정 4(세 메뉴 복원)를 뒤집는다.** 그 복원 자체가
 *   2026-06 제거를 뒤집은 것이었다 — 제거 → 복원 → 숨김으로 세 번째다.
 *   그래서 세 결정의 흔적을 모두 남긴다: 다음에 이 자리를 건드리는 사람이
 *   "왜 또?" 를 물을 때 답이 코드 안에 있어야 한다.
 *
 * 라우트는 살아 있다(직접 URL·기존 링크 동작). 특히 로봇 상세 '부품' 탭이
 * `/parts/lots/:id`(LOT 영향권)로 링크하므로 그 경로는 계속 필요하다 —
 * 2026-06 에 라우트까지 걷어냈다가 같은 이유로 되살린 이력이 있다.
 */
export const NAV_HIDDEN_ROUTES: ReadonlyArray<string> = [
  '/parts/catalog', // 부품 카탈로그
  '/parts/lots', // 부품 입고
  '/suppliers', // 공급사
];

/** 이 사이드바 경로가 "미사용" 으로 숨겨졌는가. 역할과 무관한 판정이다. */
export function isNavHidden(to: string): boolean {
  return NAV_HIDDEN_ROUTES.includes(to);
}
